<template>
  <BasicAlert
    alertLabel="Les champs avec * sont obligatoires."
    class="form--mandatory"
  />
  <ContratResumeSection />
  <template v-if="estDossier">
    <ContratSection />
    <ContratInterruptionSection v-if="meta.contrat?.interruption?.$status !== PropertyStatus.NotPresent" />
  </template>
</template>

<script setup lang="ts">
  import ContratSection from './sections/contrat/ContratSection.vue'
  import ContratResumeSection from './sections/contrat/ContratResumeSection.vue'
  import ContratInterruptionSection from './sections/contrat/ContratInterruptionSection.vue'
  import { PropertyStatus } from '@/features/domaine/property-status'
  import { inject } from 'vue'
  import { DEMANDE_STORE } from '@/features/interface/demande/shared'

  const store = inject(DEMANDE_STORE)!.getStore<'MODEL_CXPI'>()
  const { meta, estDossier } = store
</script>
